import React, { useRef, useEffect } from "react";


const Preloader = () => {
  const loader = useRef(null);

  useEffect(() => {
    const hideLoader = () => {
      loader.current?.classList.add("loaded");
    };

    window.addEventListener("load", hideLoader);
    return () => window.removeEventListener("load", hideLoader);
  }, []);

  return (
    <div className="preloader" ref={loader}>
      <div className="spinner"></div>
    </div>
  );
};

export default Preloader;
